<template>
  <svg width="100%"
       height="36px" style="display: block" >
    <g v-for="vente in ventes" :key="vente.key" :ref="vente.key" @click="ajouterAuPanier(vente)"
      v-bind:class="{'pointer': typeVente != sansTypeVente}">
      <rect
        :x="vente.x1WithPaddingString" y="0" :width="vente.widthWithPaddingString"
        rx="2" ry="2" height="100%"
        :stroke="vente.stroke" stroke-width="2" :fill="vente.fill"/>
      <rect v-if="vente.widthOccupation > 0"
        :x="vente.x1WithPaddingString" y="0"
        :width="vente.widthOccupationString" rx="2" ry="2" height="100%"
        stroke-width="0" :fill="vente.colorOccupation"/>
      <text v-if="vente.texte && !vente.selectionne"
        :x="vente.x2WithPaddingString" y="50%" dominant-baseline="central" text-anchor="end"
        font-size="10" fill="black">{{ vente.texte }}&#xA0;</text>
      <text v-if="vente.texte && vente.selectionne"
        :x="vente.xmilieuWithPaddingString" y="50%" dominant-baseline="central" text-anchor="middle"
        font-size="14" fill="white" style="font-weight:bold;">{{ vente.texte }}</text>
    </g>
  </svg>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import getRectangle from '@/services/catalogue/planningHelper';
import decorateurRectanglePanneauxNumeriquesSemaine from '@/services/decorateur/decorateurRectanglePanneauxNumeriquesSemaine';
import decorateurRectanglePanneauxNumeriquesVente from '@/services/decorateur/decorateurRectanglePanneauxNumeriquesVente';
import { GRANULARITY, GRANULARITY_WEEK, SANS_TYPE_VENTE } from '@/components/creationOpportunite/configuration/planningNumeriqueConf';
import * as types from '@/store/creationOpportunite/venteNumerique-mutation-type';

const VenteNumerique = createNamespacedHelpers('venteNumerique');

export default {
  props: ['data', 'index'],
  data() {
    return {
      sansTypeVente: SANS_TYPE_VENTE,
      dataSelectionAccess: {},
    };
  },
  computed: {
    ...VenteNumerique.mapGetters([
      'criterePlanning',
      'typeVente',
    ]),
    ventes() {
      const ventesArray = [];
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateStart.clone().add(this.criterePlanning.days, 'days');

      for (const m = moment(dateStart); m.diff(dateEnd, 'days') <= 0; m.add(7, 'days')) {
        const dateFinSemaine = m.clone().add(6, 'days');
        const result = getRectangle(this.criterePlanning, m, dateFinSemaine);
        if (result !== null) {
          const key = `r${this.data.num}${m.format('YYYYMMDD')}`;
          if (this.dataSelectionAccess[key]) {
            result.selectionne = this.dataSelectionAccess[key];
          }
          decorateurRectanglePanneauxNumeriquesSemaine(result, this.data.faces, m, dateFinSemaine);
          decorateurRectanglePanneauxNumeriquesVente(result, this.data.num, m, GRANULARITY_WEEK);
          ventesArray.push(result);
        }
      }
      return ventesArray;
    },
  },
  methods: {
    ...VenteNumerique.mapActions({
      actionsGestionPanier: 'gestionPanier',
    }),
    ...VenteNumerique.mapMutations({
      setPanneauSelected: types.SET_PANNEAU_SELECTED,
    }),
    ajouterAuPanier(vente) {
      if (this.typeVente === this.sansTypeVente) {
        return;
      }
      this.setPanneauSelected({
        panNum: vente.panNum,
        value: true,
      });
      const tarification = this.typeVente + GRANULARITY[GRANULARITY_WEEK].value;
      this.$set(this.dataSelectionAccess, vente.key, this.typeVente);
      this.actionsGestionPanier({
        panNum: vente.panNum,
        periode: vente.periode,
        tarification: tarification,
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/recherche/planningNumeriqueSemaineSvg.vue